import { useState } from "react";
import styles from "../styles/footer.module.css";

const Footer = () => {
  const [isTooltipVisible, setTooltipVisible] = useState(false);

  const handleMouseEnter = () => {
    setTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    setTooltipVisible(false);
  };

  const handleEmailClick = () => {
    const email = "amitrai9322@gmail.com";
    const mailtoLink = `mailto:${email}`;
    window.location.href = mailtoLink;
  };

  return (
    <div className={styles.container}>
      <div className={styles.footer}>
        <h1 style={{ fontSize: "2rem" }}>
          <span style={{ color: "#3ABFF8" }}>💬 </span>
          Get In Touch
        </h1>
        <p style={{ lineHeight: "1.7rem", color: "#b3c5efcc" }}>
          I'm open to new opportunities! Feel free to drop me a message with any
          questions, ideas, or just to say hello. I'll get back to you quickly,
          and I'm eager to explore potential collaborations. Let's connect and
          make something extraordinary together!
        </p>
        <div className={styles.tooltipContainer}>
          <button
            className={styles.helloBtn}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleEmailClick}
          >
            SAY HELLO
          </button>
          {isTooltipVisible && (
            <div className={styles.tooltip}>amitrai9322@gmail.com</div>
          )}
        </div>
      </div>
      <p style={{ paddingBottom: "2rem", fontSize: "1.1rem" }}>
        Made with ❤️ by Amit Rai
      </p>
    </div>
  );
};

export default Footer;
